import React from "react";
import "./internship.css";
import Footer from "../Footer";

function Internship() {
  return (
    <>
      <header className="page-hero page-hero--plain">
        <div className="page-hero__inner">
          <p className="page-hero__eyebrow">Opportunity</p>
          <h1 className="page-hero__title internship-header" id="internship-titlebox">
            INTERNSHIP OPPORTUNITY
          </h1>
        </div>
      </header>

      <div className="internship-container">

        <section className="u-spread detail-section">
          <h2 className="u-spread-label">Objective</h2>
          <div className="detail-section__body">
            <p className="internship-subheader internship-lede">
              Assist in validation (and to some extent participate in development) of a high-resolution, gridded environmental dataset for the Austin, TX metro area using advanced AI/ML techniques to support city disaster studies and planning. This remote, 3-month summer project is ideal for candidates with strong meteorological expertise and a deep understanding of model validation and physical interpretability.
            </p>
          </div>
        </section>

        <section className="u-spread detail-section">
          <h2 className="u-spread-label">Important Note</h2>
          <div className="detail-section__body">
            <p className="internship-subheader internship-note">
              <strong>We are specifically seeking a candidate with a strong background in meteorology, weather/climate datasets, and model validation.</strong><br />
              Candidates without strong meteorological model–data validation experience will <em>not</em> be considered.<br />
              <br />
              <em>This role is <strong>not a generic ML internship</strong> — domain knowledge and the ability to assess scientific rigor and physical plausibility are critical to success.</em>
            </p>
          </div>
        </section>

        <section className="u-spread detail-section">
          <h2 className="u-spread-label">Scope of Work</h2>
          <div className="detail-section__body">
            <ul className="contentlist internship-subheader">
              <li>Validate and help build spatiotemporal datasets at 30m, 100m, and 300m resolution, with hourly temporal granularity from 1979–present.</li>
            </ul>

            <h3 className="internship-subheader">Key Tasks</h3>
            <ul className="contentlist internship-subheader">
              <li>Ingest and process meteorological and satellite datasets (e.g., ERA5, land surface temperature, urban morphology).</li>
              <li>Apply state-of-the-art ML methods while maintaining physical consistency.</li>
              <li><strong>MAJORITY FOCUS:</strong> Validation of output using meteorological standards and ensuring scientific soundness of spatiotemporal patterns.</li>
            </ul>

            <p className="internship-subheader">
              Generate interpretable outputs focused on city-relevant use cases, especially extreme heat and rainfall extremes.
            </p>
          </div>
        </section>

        <section className="u-spread detail-section">
          <h2 className="u-spread-label">Expected Outputs by End of Summer Internship</h2>
          <div className="detail-section__body">
            <ul className="contentlist internship-subheader">
              <li><strong>Scientifically rigorous validation</strong> of a high-resolution spatiotemporal dataset for the Austin metro area.</li>
              <li>Reproducible code pipelines with detailed validation and QA/QC steps.</li>
              <li>Summary figures and visuals emphasizing urban heat, rainfall products, and other adaptation-relevant metrics.</li>
              <li>Modular outputs ready for integration with policy and research applications.</li>
            </ul>
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
}

export default Internship;
